import { AppAPI, } from '@moderepo/mode-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var HomeKVStoresActionType;
(function (HomeKVStoresActionType) {
    HomeKVStoresActionType["SET_HOME_KV_STORES"] = "set home kv stores";
    HomeKVStoresActionType["SET_HOME_KV_STORE"] = "set home kv store";
    HomeKVStoresActionType["REMOVE_HOME_KV_STORE"] = "remove home kv store";
    HomeKVStoresActionType["CLEAR_HOME_KV_STORES"] = "clear home kv stores";
})(HomeKVStoresActionType || (HomeKVStoresActionType = {}));
export const setHomeKVStores = (homeId, kvStores, searchParams) => {
    return {
        type: HomeKVStoresActionType.SET_HOME_KV_STORES,
        homeId,
        kvStores,
        searchParams,
    };
};
export const setHomeKVStore = (homeId, kvStore) => {
    return {
        type: HomeKVStoresActionType.SET_HOME_KV_STORE,
        homeId,
        kvStore,
    };
};
export const removeHomeKVStore = (homeId, key) => {
    return {
        type: HomeKVStoresActionType.REMOVE_HOME_KV_STORE,
        homeId,
        key,
    };
};
export const clearHomeKVStores = (homeId) => {
    return {
        type: HomeKVStoresActionType.CLEAR_HOME_KV_STORES,
        homeId,
    };
};
/**
 * Fetch all key/value pairs for a given device
 */
export const fetchAllHomeKVStores = (homeId, keyPrefix) => {
    return async (dataDispatch) => {
        const keyValuePairs = await AppAPI.getInstance().getAllHomeKeyValuePairs(homeId, keyPrefix);
        await dataDispatch(setHomeKVStores(homeId, keyValuePairs, searchParamsToString({
            keyPrefix,
        })));
    };
};
/**
 * Fetch a home's key/value pair
 */
export const fetchHomeKVStore = (homeId, key) => {
    return async (dataDispatch) => {
        const keyValuePair = await AppAPI.getInstance().getHomeKeyValuePair(homeId, key);
        await dataDispatch(setHomeKVStore(homeId, keyValuePair));
    };
};
/**
 * Update a home's key value pair
 * @param homeId - The id of the home which we want to update
 * @param key - The key of the KV pair we want to update
 * @param value - The new value of the key value pair
 */
export const updateHomeKVStore = (homeId, key, value) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().updateHomeKeyValuePair(homeId, key, value);
        // Home KV updated, we need to reload the data
        await dataDispatch(fetchHomeKVStore(homeId, key));
    };
};
/**
 * Delete a home's key value pair
 * @param homeId - The id of the home which we want to delete
 * @param key - The key of the KV pair we want to delete
 */
export const createHomeKVStore = (homeId, key, value) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().createHomeKeyValuePair(homeId, key, value);
        // KV store added so we need to clear the cached list of home's KV stores
        await dataDispatch(clearHomeKVStores(homeId));
    };
};
/**
 * Delete a home's key value pair
 * @param homeId - The id of the home which we want to delete
 * @param key - The key of the KV pair we want to delete
 */
export const deleteHomeKVStore = (homeId, key) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().deleteHomeKeyValuePair(homeId, key);
        // KV store is deleted so we need to clear the cached list of home's KV stores
        await dataDispatch(clearHomeKVStores(homeId));
        await dataDispatch(removeHomeKVStore(homeId, key));
    };
};
